const convertToLowercase = (obj) => {
  if (Array.isArray(obj)) {
    return obj.map(convertToLowercase);
  } else if (obj !== null && typeof obj === 'object') {
    return Object.fromEntries(
      Object.entries(obj).map(([key, value]) => [
        key.toLowerCase(),
        convertToLowercase(value)
      ])
    );
  }
  return obj;
}

export default convertToLowercase
